
<template>
    <div>

		<div class="app-title">
			<div>
				<h1>{{ $t("lbl.user") }}</h1>
			</div>
		</div>

        <section class="app-content">
            <div class="card-columns">
            <div class="card">
                <h3 class="card-header text-center"><span class=" text-primary">{{$t('lbl.user.userCenter')}}</span></h3>  
                <ul class="user-info">
                    <li><i class="fas fa-user"> {{$t('lbl.user.name')}}</i>  <div class="user-right">{{user.name}}</div></li>
                    <li><i class="fas fa-mobile"> {{$t('lbl.user.mobile')}}</i> <div class="user-right" >{{user.mobile}}</div></li>
                    <li><i class="fas fa-envelope"> {{$t('lbl.user.mail')}}</i> <div class="user-right">{{user.mail}}</div></li>
                    <!-- <li><i class="fas fa-building"> {{$t('lbl.user.departmentName')}}</i> <div class="user-right">{{user.departmentId}}</div></li>
                    <li><i class="fas fa-calendar-minus"> {{$t('lbl.user.createDate')}}</i> <div class="user-right">2019-10-17</div></li> -->
                    <li><i class="fas fa-user-lock"> {{$t('lbl.user.security')}}</i> <div class="user-right">
                    <mmf-button type="changePwd" show-name v-bind:class="'btn btn-primary'" v-on:click="changePassword"></mmf-button>
                </div>
              </li>
            </ul>

            </div>  
            </div>          
        </section>
    </div>    
</template>

<script>
import MmfButton from "@/components/MmfButton";
// import { fields} from "@/model/adm/UserSetting";
// const {mapFields} = createHelpers({
//     getterType: 'userSetting/getField',
//     mutationType: 'userSetting/updateField',
// });

export default {
  name: "userCenter",
  data() {
        return {
          user:[]
        }
        },
  methods: {
    changePassword() {
        var url = process.env.VUE_APP_KEYCLOAK_URL+'/realms/'+process.env.VUE_APP_KEYCLOAK_REALM+'/account/password';
        var name = '更改密码';
        var iWidth = 900;                                     //弹出窗口的宽度;
        var iHeight = 500;                                    //弹出窗口的高度;
        var iTop = (window.screen.height-30-iHeight)/2;       //获得窗口的垂直位置;
        var iLeft = (window.screen.width-10-iWidth)/2;        //获得窗口的水平位置;

        window.open(url,name,'height='+iHeight+',innerHeight='+iHeight+',width='+iWidth +',innerWidth='+iWidth+',top='
        +iTop+',left='+iLeft+',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no');
        },
  },
  components: {
    MmfButton
  },
  created() {
        this.$store.dispatch("api/get", {
                url: this.$store.state.userSetting.baseModuleUrl + "/user/findUser"
            }, {
                root: true
            })
            .then(data => {
                this.user = data;
            })}
};
</script>

<style rel="stylesheet/scss" lang="scss">
  .avatar-uploader-icon {
    font-size: 28px;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border-radius: 50%
  }
  .user-info {
    padding: 15px;
    list-style: none;
    li{
      border-bottom: 1px solid #F0F3F4;
      border-top: 1px solid #F0F3F4;
      padding: 11px 0px;
      font-size: 13px;
    }
    .user-right {
      float: right;

      a{
        color: #317EF3;
      }
    }
  }
</style>